import React from 'react';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';

export const OpenSubmissionsCapsuleSettingsText = `Open Submissions Capsule Settings`;

export default function OpenSubmissionsCapsuleSettings() {
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    return (
        <div className="SymbolTileSettings">
            <AppSettingsEditor
                appSettings={appSettings}
                onAppSettingsChanged={dispatchUpdateAppSettings}
                specifyVisibleControls={{
                    showChartHelp: true,
                }}
            />
        </div>
    );
}
